import React, { Component } from "react";
import styled from "styled-components";
import Icon from "../UI/Icon/Icon";
import { SmallButtonPurple } from "../UI/Buttons/SmallButton";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as actions from "../../store/actions";
import SwitchButton from "../UI/Buttons/SwitchButton";
import Checkbox from "../UI/Forms/Checkbox";

const PanelContainer = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 3px;
  border: 1px solid rgba(23, 15, 48, 0.25);
  border-top: 0px;
  margin-top: 5px;
  /* min-height: calc(60vh + 120px); */
  height: 100%;
  overflow: scroll;
`;
const AddToTodoistButtonContainer = styled.div`
  height: 25px;
`;
const Heading = styled.h2`
  color: #333;
  font-size: 1.5rem;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;
const IconWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
`;

const Description = styled.div`
  color: #666;
  font-size: 1rem;
  line-height: 1.4;
`;
const ActionItemContainer = styled.div`
  padding: 5px 0px;
  margin-bottom: 10px;
  border-bottom: 1px solid #00000014;
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
`;

const Timestamp = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
  cursor: pointer;
`;

const Content = styled.div`
  margin-bottom: 10px;
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  gap: 5px;
`;
const TimestampHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
`;
const GroupContainer = styled.div`
  /* border: 1px solid black; */
  /* text-decoration: underline; */
  margin-bottom: 5px;
  padding: 5px;
`;

class TodolistPanel extends Component {
  state = {
    backendMeetingNotes: {
      id: this.props.meetingNotes.meetingId,
      notes_id: this.props.meetingNotes.notesId,
      overview: this.props.meetingNotes.overview,
      summary: this.props.meetingNotes.summary,
      action_items: this.props.meetingNotes.actionItems,
      timestamp_ranges: this.props.meetingNotes.timestampRanges,
    },
    expandedGroups: this.props.meetingNotes.timestampRanges
      ? { [this.props.meetingNotes?.timestampRanges[0]]: true }
      : {}, // By default open the first time range block in action Items
    expandAll: false,
    editedContent: "",
    editIndex: null,
    userIsHost: this.props.userIsHost,
    actionItemsCheckedObj: {},
    displayAddToTodoistButton: true,
  };
  componentDidMount() {
    let initialActionItemsCheckedObj = {};
    initialActionItemsCheckedObj = this.initializeActionItemsCheckedObj(
      initialActionItemsCheckedObj
    );

    this.setState({
      actionItemsCheckedObj: initialActionItemsCheckedObj,
      expandedGroups: this.props.meetingNotes.timestampRanges
        ? { [this.props.meetingNotes?.timestampRanges[0]]: true }
        : {},
    });
  }
  componentDidUpdate(prevProps, prevState) {
    // This will run whenever props or state change
    const { meetingNotes, userIsHost } = this.props;
    // Check if the dependencies have changed
    if (meetingNotes !== prevProps.meetingNotes) {
      let initialActionItemsCheckedObj = {};
      initialActionItemsCheckedObj = this.initializeActionItemsCheckedObj(
        initialActionItemsCheckedObj
      );
      this.setState({
        expandAll: false,
        expandedGroups: this.props.meetingNotes.timestampRanges
          ? { [this.props.meetingNotes?.timestampRanges[0]]: true }
          : {},
        backendMeetingNotes: {
          id: this.props.meetingNotes.meetingId,
          notes_id: this.props.meetingNotes.notesId,
          overview: this.props.meetingNotes.overview,
          summary: this.props.meetingNotes.summary,
          action_items: this.props.meetingNotes.actionItems,
          timestamp_ranges: this.props.meetingNotes.timestampRanges,
        },
        actionItemsCheckedObj: initialActionItemsCheckedObj,
      });
    }
    if (userIsHost !== prevProps.userIsHost) {
      this.setState({
        userIsHost: this.props.userIsHost,
      });
    }
  }
  allActionItemsUnchecked = (actionItemsCheckedObj) => {
    let allActionItemsAreUnchecked = true;
    Object.values(actionItemsCheckedObj).forEach((actionItemChecked) => {
      if (actionItemChecked) {
        allActionItemsAreUnchecked = false;
      }
    });
    return allActionItemsAreUnchecked;
  };
  initializeActionItemsCheckedObj = (actionItemsCheckedObj) => {
    if (this.props.meetingNotes.actionItems) {
      this.props.meetingNotes.actionItems.forEach((actionItem, index) => {
        actionItemsCheckedObj[actionItem.number] = false;
      });
    }

    return actionItemsCheckedObj;
  };

  toggleGroup = (timestampRange) => {
    this.setState((prevState) => ({
      expandedGroups: {
        ...prevState.expandedGroups,
        [timestampRange]: !prevState.expandedGroups[timestampRange],
      },
    }));
  };
  toggleAll = (groupedItems) => {
    this.setState((prevState) => {
      const nextExpandAllState = !prevState.expandAll;
      let newExpandedGroups = {};

      if (nextExpandAllState) {
        // Logic for "Expand All": Put every key into the object
        Object.keys(groupedItems).forEach((timestampRange) => {
          newExpandedGroups[timestampRange] = true;
        });
      } else {
        // Logic for "Collapse All": Leave the object empty
        newExpandedGroups = {};
      }

      return {
        expandAll: nextExpandAllState,
        expandedGroups: newExpandedGroups,
      };
    });
  };
  handleEdit = (index, content) => {
    this.setState({
      editIndex: index,
      editedContent: content,
    });
  };
  onAddToTodoistButtonClick = () => {
    let actionItemNumbersToStore = [];
    Object.entries(this.state.actionItemsCheckedObj).forEach(
      ([actionItemNumber, checked], index) => {
        if (checked) {
          actionItemNumbersToStore.push(actionItemNumber);
        }
      }
    );
    this.props
      .storeActionItemsInTodoist(
        this.props.accessToken,
        this.props.meetingNotes.notesId,
        actionItemNumbersToStore
      )
      .then(() => {
        let newActionItemsCheckedObj = this.state.actionItemsCheckedObj;
        newActionItemsCheckedObj = this.initializeActionItemsCheckedObj(
          newActionItemsCheckedObj
        );

        this.setState({
          actionItemsCheckedObj: newActionItemsCheckedObj,
          displayAddToTodoistButton: true,
        });
      })
      .catch((error) => {
        alert(
          "There was problem while storing your action items in Todoist. Please contact support@capturemymeeting.com."
        );
      });
  };

  handleSave = () => {
    const { editIndex, editedContent, backendMeetingNotes } = this.state;

    if (editIndex !== null) {
      const updatedActionItems = [...backendMeetingNotes.action_items];
      updatedActionItems[editIndex].content = editedContent;

      const updatedNotes = {
        ...backendMeetingNotes,
        action_items: updatedActionItems,
      };

      // Update local state first for immediate UI feedback
      this.setState({
        backendMeetingNotes: updatedNotes,
        editIndex: null,
        editedContent: "",
      });

      // Send the request
      this.props.updateMeetingNotes(this.props.accessToken, updatedNotes);
    }
  };

  handleCancel = () => {
    this.setState({
      editIndex: null,
      editedContent: "",
    });
  };

  // handleKeyPress = (event, index) => {
  //   if (event.key === "Enter") {
  //     this.handleSave(index);
  //   }
  // };
  onActionItemChecked = (actionIdNumber) => {
    let newActionItemsCheckedObj = {};
    let displayAddToTodoistButton = this.state.displayAddToTodoistButton;
    Object.keys(this.state.actionItemsCheckedObj).forEach(
      (actionItemNumberKey, idx) => {
        if (parseInt(actionItemNumberKey, 10) === actionIdNumber) {
          newActionItemsCheckedObj[actionItemNumberKey] =
            !this.state.actionItemsCheckedObj[actionItemNumberKey];
        } else {
          newActionItemsCheckedObj[actionItemNumberKey] =
            this.state.actionItemsCheckedObj[actionItemNumberKey];
        }

        if (this.allActionItemsUnchecked(newActionItemsCheckedObj)) {
          displayAddToTodoistButton = true;
        } else {
          displayAddToTodoistButton = false;
        }
      }
    );

    this.setState({
      displayAddToTodoistButton: displayAddToTodoistButton,
      actionItemsCheckedObj: newActionItemsCheckedObj,
    });
  };
  showTodoistOptions = () => {
    let showTodoistOptions =
      this.props.todoistIntegrated && this.props.todoistAccessTokenExists;
    return showTodoistOptions;
  };

  render() {
    const { expandedGroups, editedContent, editIndex, meetingNotes } =
      this.state;
    let groupedItems = [];
    let timestampRange = [];
    if (this.props.meetingNotes.actionItems) {
      groupedItems = this.props.meetingNotes.actionItems.reduce(
        (groups, item) => {
          const timestampRange = item.timestamp_range;
          groups[timestampRange] = groups[timestampRange] || [];
          groups[timestampRange].push(item);
          // this.toggleGroup(timestampRange);
          return groups;
        },
        {}
      );
    }

    let cumulativeIndex = 0;

    return (
      <PanelContainer>
        <Header>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Heading>TodoList</Heading>
            <SwitchButton
              option1="Collapse"
              option2="Expand"
              containerStyle={{
                margin: "0px",
                zIndex: "1",
              }}
              buttonStyle={{ width: "130px", height: "20px" }}
              buttonWidth="130px"
              labelStyle={{ fontSize: "10px" }}
              onClick={() => this.toggleAll(groupedItems)}
              buttonState={this.state.expandAll}
            />
          </div>

          {this.showTodoistOptions() ? (
            <AddToTodoistButtonContainer>
              <SmallButtonPurple
                type="button"
                loading={this.props.meetingNotes.loading}
                disabled={
                  this.props.meetingNotes.loading ||
                  this.state.displayAddToTodoistButton
                }
                onClick={this.onAddToTodoistButtonClick}
              >
                Add to Todoist
              </SmallButtonPurple>
            </AddToTodoistButtonContainer>
          ) : null}
          <IconWrapper
            onClick={() => {
              // let allActionItems = "";
              // this.props.meetingNotes.actionItems.map((item, index) => {
              //   allActionItems += `${index + 1}) ${item.content} \n`;
              // });
              let allActionItems = "";
              if (
                this.props.meetingNotes &&
                this.props.meetingNotes.actionItems
              ) {
                allActionItems = this.props.meetingNotes.actionItems
                  .map((item, index) => {
                    return `${index + 1}) ${item.content}`;
                  })
                  .join("\n");
              }
              navigator.clipboard.writeText(allActionItems);
            }}
          >
            <Icon
              style={{ width: "40px", height: "40px", cursor: "pointer" }}
              name="copy_icon"
            ></Icon>
          </IconWrapper>
        </Header>

        {this.props.meetingNotes.error ? (
          <div>
            Meeting's action items are not yet available, Please try again in
            few minutes.
          </div>
        ) : (
          <Description>
            <div>
              {Object.entries(groupedItems).map(
                ([timestampRange, itemList], index) => {
                  const groupIndex = cumulativeIndex;
                  cumulativeIndex += itemList.length;
                  return (
                    <GroupContainer key={timestampRange}>
                      <TimestampHeader>
                        <Timestamp
                          onClick={() => this.toggleGroup(timestampRange)}
                        >{`Part ${index + 1
                          } of meeting (${timestampRange})`}</Timestamp>
                        <div
                          onClick={() => this.toggleGroup(timestampRange)}
                          style={{ fontSize: "1.2rem", cursor: "pointer" }}
                        >
                          {expandedGroups[timestampRange] ? (
                            <Icon
                              style={{ padding: "5px 5px 0px 0px" }}
                              name="down_arrow"
                            />
                          ) : (
                            <Icon
                              style={{
                                padding: "5px 5px 0px 0px",
                                transform: "rotate(270deg)",
                              }}
                              name="down_arrow"
                            />
                          )}
                        </div>
                      </TimestampHeader>

                      {expandedGroups[timestampRange] && (
                        <div style={{ padding: "0px 10px 0px 10px" }}>
                          {itemList.map((groupedItem, innerIndex) => {
                            const itemIndex = groupIndex + innerIndex;
                            return (
                              <ActionItemContainer
                                title={
                                  this.state.userIsHost
                                    ? "edit Action"
                                    : "Only host can edit it"
                                }
                                key={innerIndex}
                              >
                                {this.showTodoistOptions() &&
                                  !groupedItem.stored_in_todoist ? (
                                  <Checkbox
                                    fontSize="12px"
                                    required={true}
                                    isChecked={
                                      groupedItem.number in
                                        this.state.actionItemsCheckedObj
                                        ? this.state.actionItemsCheckedObj[
                                        groupedItem.number
                                        ]
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.onActionItemChecked(
                                        groupedItem.number
                                      )
                                    }
                                    title="Select Action Item"
                                  />
                                ) : null}
                                {editIndex === itemIndex &&
                                  this.state.userIsHost ? (
                                  <>
                                    {/* <textarea
                                      value={editedContent}
                                      onChange={(e) =>
                                        this.setState({
                                          editedContent: e.target.value,
                                        })
                                      }
                                      title={
                                        this.state.userIsHost
                                          ? "edit Action"
                                          : "Only host can edit it"
                                      }
                                      onBlur={this.handleSave}
                                      // onKeyPress={(e) =>
                                      //   this.handleKeyPress(e, itemIndex)
                                      // }
                                      autoFocus
                                      style={{
                                        width: "100%",

                                        resize: "none", // Disable resizing
                                      }}
                                    /> */}
                                    <textarea
                                      value={editedContent}
                                      onChange={(e) => this.setState({ editedContent: e.target.value })}
                                      autoFocus
                                      style={{
                                        width: "100%",
                                        resize: "none",
                                        padding: "8px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc"
                                      }}
                                    />
                                    <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                                      {/* Show Save button only if text has changed */}
                                      {editedContent !== groupedItem.content && (
                                        <button
                                          onClick={this.handleSave}
                                          style={{
                                            backgroundColor: "#6f42c1",
                                            color: "white",
                                            border: "none",
                                            padding: "4px 12px",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "12px"
                                          }}
                                        >
                                          Save
                                        </button>
                                      )}
                                      <button
                                        onClick={this.handleCancel}
                                        style={{
                                          backgroundColor: "#f8f9fa",
                                          color: "#333",
                                          border: "1px solid #ccc",
                                          padding: "4px 12px",
                                          borderRadius: "4px",
                                          cursor: "pointer",
                                          fontSize: "12px"
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: "5px",
                                      width: "100%",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {/* <input
                                    style={{ marginTop: "5px" }}
                                    type="checkbox"
                                  /> */}
                                    <Content
                                      onClick={() =>
                                        this.handleEdit(
                                          itemIndex,
                                          groupedItem.content
                                        )
                                      }
                                    >
                                      {innerIndex +
                                        1 +
                                        ". " +
                                        groupedItem.content}
                                      <Icon
                                        style={{ paddingTop: "5px", cursor: "pointer" }}
                                        name="edit_icon_black"
                                      />
                                    </Content>
                                  </div>
                                )}
                              </ActionItemContainer>
                            );
                          })}
                        </div>
                      )}
                    </GroupContainer>
                  );
                }
              )}
            </div>
          </Description>
        )}
      </PanelContainer>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    storeActionItemsInTodoist: (accessToken, notesId, actionItemNumbers) =>
      dispatch(
        actions.storeActionItemsInTodoist(
          accessToken,
          notesId,
          actionItemNumbers
        )
      ),

    updateMeetingNotes: (accessToken, meetingNotes) =>
      dispatch(actions.updateMeetingNotes(accessToken, meetingNotes)),
  };
};

const mapStateToProps = (state) => {
  return {
    accessToken: state.auth.accessToken,
    meetingNotes: state.meetingNotes,
    todoistAccessTokenExists: state.user.todoistAccessTokenExists,
    todoistIntegrated: state.user.todoistIntegrated,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TodolistPanel)
);
